import {
    businessData,
    k12Data,
    serviceData,
    ukBusinessData,
    deBusinessData,
    deServicesData,
    laBusinessData,
    esBusinessData,
    esK12Data,
    esHEDData,
    frBusinessData,
    brBusinessData,
    itBusinessData,
    cnBusinessData
} from "./filterData";

/**
 * Selects the appropriate data to build filter bar based on provided vertical
 *
 * @param market
 * @param {string} vertical ['business', 'k12', services']
 * @returns {Object} data used to build filter
 */
const getData = (market, vertical) => {
    const formattedMarket = market.toString().toLowerCase();
    const hub = `${formattedMarket}-${vertical}`;
    switch (hub) {
        case "us-business":
            return businessData;
        case "us-k12":
            return k12Data;
        case "us-services":
            return serviceData;
        case "uk-business":
            return ukBusinessData;
        case "de-business":
            return deBusinessData;
        case "de-services":
            return deServicesData;
        case "la-business":
            return laBusinessData;
        case "es-business":
            return esBusinessData;
        case "es-k12":
            return esK12Data;
        case "es-hed":
            return esHEDData;
        case "fr-business":
            return frBusinessData;
        case "br-business":
            return brBusinessData;
        case "it-business":
            return itBusinessData;
        case "cn-business":
        case "cn-k12":
        case "cn-hed":
            return cnBusinessData;
        default:
            return "";
    }
};

export default getData;
